import React from "react";

import Loader from "@/components/Loader";

const LoadingView = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <Loader className="w-[30px] h-[30px] text-blue" />
    </div>
  );
};

export default LoadingView;
